import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { FormGroup, Box } from '@material-ui/core';
import { PasslyButton, PasslyTextField } from '@app/components';
import { IOffice365State } from '../appFederation.component';

interface IProps {
    setManagedConfig: Function;
    verifyMsol: Function;
    config: any;
    updateOfficeConfig: Function;
    officeConfig: IOffice365State;
}

export const ManagedConfig = ({ setManagedConfig, verifyMsol, config }: IProps) => {
    const { translation } = useTypedTranslation();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setManagedConfig(name, value);
    };

    return (
        <>
            <FormGroup>
                <div className='form__row'>
                    <PasslyTextField id='msolDomain-input' label={'MSOL_DOMAIN'} name='domain' value={config.domain} onChange={handleInputChange} fullWidth />
                </div>
                <div className='form__row'>
                    <PasslyTextField id='msolUsername-input' label={'MSOL_USERNAME'} name='username' type='email' value={config.username} onChange={handleInputChange} fullWidth />
                </div>
                <div className='form__row'>
                    <PasslyTextField id='msolPassword-input' label={'MSOL_PASSWORD'} name='password' type='password' value={config.password} onChange={handleInputChange} fullWidth />
                </div>
            </FormGroup>
            <Box mt={4}>
                <PasslyButton
                    id='verify'
                    variant='contained'
                    color='primary'
                    onClick={verifyMsol}
                    disabled={config.password === '' || config.username === '' || config.domain === ''}
                >
                    {translation('FEDERATION_VERIFY')}
                </PasslyButton>
            </Box>
        </>
    );
};
